exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".score-progress-bar {\n  border: 1px solid #414145;\n  margin-bottom: 5px; }\n  .score-progress-bar .filled {\n    height: 100%; }\n\n.labels div {\n  display: inline-block;\n  color: #79a1bb; }\n\n.max-label {\n  float: right; }\n\n.passing-score-label {\n  margin-top: 10px; }\n\n@media (max-width: 767px) {\n  .score-progress-bar {\n    width: 90%;\n    margin: auto; }\n  .passing-score-label {\n    margin-left: 15px; }\n  .labels div {\n    margin: 0px 20px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/score-progress-bar/score-progress-bar.scss
// module id = +NRC
// module chunks = 3